import { CustomerFundingRateConfiguration } from '@src/containers/Dealer/CustomerFundingRateConfiguration';
import type { CustomerFundingRateConfigurationPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerFundingRateConfigurationPanel({
  api,
  params,
}: LayoutPanelProps<CustomerFundingRateConfigurationPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-funding-rate-configuration-panel"
    >
      <CustomerFundingRateConfiguration />
    </EntityAdminPanelShell>
  );
}
